import {BlackbirdPermissionCaches} from '@github-ui/blackbird-warm-caches'

const blackbirdCaches = new BlackbirdPermissionCaches()

/**
 * Starts the self-rescheduling Blackbird permission-cache warming loop when a user shows intent to search.
 * Safe to call repeatedly; only the first call starts the loop for the page.
 */
export function warmBlackbirdCaches(): void {
  void blackbirdCaches.setupWarmCachesLoop()
}
